import { useDispatch } from "react-redux";
import { logout } from "../../actions/login.action";
import { resolveSessionExtension } from "../../actions/session.action";
import Modal from "../modal";

export default function SessionExpiredConsent() {
  const storeDispatch = useDispatch();

  function handleExtend() {
    resolveSessionExtension(true);
  }

  function handleLogout() {
    resolveSessionExtension(false);
    logout(storeDispatch);
  }

  return (
    <Modal
      open
      title="Session expired"
      description="Your session has expired due to inactivity."
      onClose={() => {}}
      hasCloseIcon={false}
      closeOnBackdropClick={false}
      closeOnEscPress={false}
      hasSubmitButton
      submitButtonText="Extend session"
      onSubmit={handleExtend}
      hasCancelButton
      cancelButtonText="Log out"
      onCancel={handleLogout}
    >
      <p>
        Your session has expired because you were inactive for a while. Do you
        want to continue working?
      </p>
    </Modal>
  );
}
